import {
    MaybeRefOrGetter, onMounted, ref, toValue, watch
} from 'vue';
import { GridApi } from '@ag-grid-community/core';

/**
 * Auto-resize the grid if the grid size changes
 * @param rows grid rows ref
 * @param gridApi grid API ref
 * @param gridId id of the grid component to watch for size changes
 */
export function useAutoResizingGrid<TRow>(
    rows: MaybeRefOrGetter<TRow[]>,
    gridApi: MaybeRefOrGetter<GridApi<TRow> | undefined>,
    gridId: string
) {
    const gridElement = ref(document.getElementById(gridId));
    function resizeGrid(api?: GridApi<TRow>) {
        if (api && toValue(rows)) {
            api.sizeColumnsToFit();
        }
    }

    const resizeObserver = new ResizeObserver(() => resizeGrid(toValue(gridApi)));
    onMounted(() => {
        gridElement.value = document.getElementById(gridId);
        if (gridElement.value)
            resizeObserver.observe(gridElement.value);
    });

    const stopRowWatch = watch([ rows, gridElement ], () => {
        const api = toValue(gridApi);
        if (api && toValue(rows) && gridElement.value)
        {
            resizeGrid(api);
            stopRowWatch();
        }
    });

    return {
        stopRowWatch,
        resizeObserver
    };
}